import { clone, mergeDeepWith } from 'ramda';

export const deposit = {};

export const withdraw = mergeDeepWith(clone, deposit, {});

export const portalAccountFieldsConfig = { deposit, withdraw };
